import { Link } from "react-router-dom";

import { formatDuration } from "../lib/transcript";
import type { CatalogEntry } from "../lib/types";

import { Chip } from "./atoms";

/** A library card: series, title, speaker, duration and the first gem. */
export function VideoCard({ entry }: { entry: CatalogEntry }) {
  return (
    <Link
      to={`/video/${entry.id}`}
      className="plate flex flex-col gap-2 p-4 transition-transform hover:-translate-y-0.5"
    >
      <div className="flex items-center justify-between gap-2">
        <Chip>{entry.series}</Chip>
        <span className="text-xs text-warm-gray tabular-nums">
          {formatDuration(entry.duration)}
        </span>
      </div>
      <h3 className="font-display text-lg leading-snug text-warm-brown">
        {entry.title}
      </h3>
      <p className="text-sm text-warm-gray">
        {entry.speaker}
        {entry.year !== null ? ` · ${entry.year}` : ""}
      </p>
      {entry.gem !== null ? (
        <p className="mt-1 border-t border-hairline pt-2 font-serif text-sm italic leading-relaxed text-warm-brown-light">
          {entry.gem}
        </p>
      ) : null}
    </Link>
  );
}
